module.exports = __webpack_public_path__ + "static/media/resetBalance.759c91bd.png";